module.exports = __webpack_public_path__ + "img/cart.6c48ff20.png";